<template>
  <div class="mainContainer">
    <el-container class="centerContainer">
      <el-row style="background: #fafafa">
        <el-col :sm="12" :md="10" class="leftMainRow">
          <el-row class="mainForm mainLeftBorder">
            <el-col class="mainSelect">
              <el-row>
                <el-col :sm="24">
                  <h6>
                    <strong
                      >TIPO DE BÚSQUEDA<span class="requiredColor"
                        >*</span
                      ></strong
                    >
                  </h6>
                </el-col>
                <el-col :sm="24">
                  <el-select filterable v-model="localSelected">
                    <el-option
                      v-for="item in locales"
                      :label="item.text"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col class="mainSelect">
              <el-row>
                <el-col :sm="24">
                  <h6>
                    <strong
                      >SELECCIONAR DEPARTAMENTO<span class="requiredColor"
                        >*</span
                      ></strong
                    >
                  </h6>
                </el-col>
                <el-col :sm="24">
                  <el-select filterable v-model="departamentoSelected">
                    <el-option
                      v-for="item in _departamentos"
                      :value="item.idDepa"
                      :key="item.idDepa"
                      :label="item.departamento"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col class="mainSelect">
              <el-row>
                <el-col :sm="24">
                  <h6>
                    <strong
                      >SELECCIONAR PROVINCIA<span class="requiredColor"
                        >*</span
                      ></strong
                    >
                  </h6>
                </el-col>
                <el-col :sm="24">
                  <el-select filterable v-model="provinciaSelected">
                    <el-option
                      v-for="item in _provincias"
                      :value="item.idProv"
                      :key="item.idProv"
                      :label="item.provincia"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col class="mainSelect">
              <el-row>
                <el-col :sm="24">
                  <h6>
                    <strong
                      >SELECCIONAR DISTRITO<span class="requiredColor"
                        >*</span
                      ></strong
                    >
                  </h6>
                </el-col>
                <el-col :sm="24">
                  <el-select filterable v-model="distritoSelected">
                    <el-option
                      v-for="item in _distritos"
                      :value="item.idUbigeo"
                      :key="item.idUbigeo"
                      :label="item.distrito"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
        <el-col :sm="12" :md="14" class="rightMainRow">
          <el-row class="mainForm">
            <el-col style="padding: 0 0 0 16px">
              <span class="mainTitle"
                ><strong>LOCALES DISPONIBLES</strong></span
              >
            </el-col>
            <el-col class="itemContainer" v-if="sedesDisponibles.length > 0">
              <div
                v-for="item in sedesDisponibles"
                :key="item.unique"
                style="padding: 8px 0"
              >
                <el-row
                  style="
                    width: 100%;
                    max-width: 240px;
                    height: 4px;
                    background: #df030a;
                    border-radius: 36px;
                  "
                ></el-row>

                <el-row class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <span class="mainsubtitle">DIRECCIÓN</span>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">
                      {{ item.provincia }} - {{ item.distrito }}
                    </span>
                    <span class="mainDescription">{{ item.direccion }}</span>
                  </el-col>
                </el-row>
                <el-row v-if="item.razonSocial" class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <span class="mainsubtitle">RAZÓN SOCIAL</span>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">{{ item.razonSocial }}</span>
                  </el-col>
                </el-row>

                <el-row v-if="item.compania" class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <span class="mainsubtitle">COMPAÑÍA</span>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">{{ item.compania }}</span>
                  </el-col>
                </el-row>

                <el-row v-if="item.nombreContacto" class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <span class="mainsubtitle">CONTÁCTO</span>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">{{
                      item.nombreContacto
                    }}</span>
                  </el-col>
                </el-row>

                <el-row v-if="item.telefono" class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <span class="mainsubtitle">TELEFONO</span>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">
                      <a :href="`tel:${item.telefono}`">{{ item.telefono }}</a>
                    </span>
                  </el-col>
                </el-row>

                <el-row v-if="item.correo" class="itemTable">
                  <el-col :sm="7" class="leftTable">
                    <h6 class="mainsubtitle">CORREO</h6>
                  </el-col>
                  <el-col :sm="17" class="rightTable">
                    <span class="mainDescription">{{ item.correo }}</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col style="padding: 0 0 0 16px" v-else>
              <h6>
                <strong
                  >Hola, para poder brindarte información, seleccionar los
                  filtros de busqueda(*)</strong
                >
              </h6>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-container>
  </div>
</template>

<script>
import { mixins } from "@/mixins/mixin.js";
import axios from "axios";
export default {
  name: "App",
  mixins: [mixins],
  components: {},
  data: () => ({
    departamentoSelected: "15",
    provinciaSelected: "127",
    distritoSelected: "1291",
    localSelected: "id_tienda_propia",
    locales: [],
    datos: [],
  }),
  watch: {
    localSelected() {
      this.departamentoSelected = this._departamentos[0].idDepa;
    },
    departamentoSelected() {
      this.provinciaSelected = this._provincias[0].idProv;
      this.distritoSelected = null;
    },
  },

  computed: {
    _datos() {
      const data = this.datos.filter(
        (x) => x.idTipoLocal == this.localSelected
      );

      let newData = [];
      data.map((x) => {
        const unique = Math.floor(Math.random() * 100);

        const itemProvincia = this.distritos.find(
          (y) => y.idUbigeo == x.idUbigeo
        );
        const itemDepartamento = this.provincias.find(
          (y) => y.idProv == itemProvincia.idProv
        );
        newData.push({
          ...x,
          idDepa: itemDepartamento.idDepa,
          idProv: itemProvincia.idProv,
          provincia: itemDepartamento.provincia,
          distrito: itemProvincia.distrito,
          unique,
        });
      });
      return newData;
    },
    sedesDisponibles() {
      if (
        this.departamentoSelected &&
        this.provinciaSelected &&
        !this.distritoSelected
      ) {
        return this._datos.filter((x) => x.idProv == this.provinciaSelected);
      } else if (this.distritoSelected) {
        return this._datos.filter((x) => x.idUbigeo == this.distritoSelected);
      } else {
        return [];
      }
    },
    _departamentos() {
      let items = [];
      this._datos.map((x) => items.push(x.idDepa));
      const uniqueItems = [...new Set(items)];
      let lista = [];
      uniqueItems.map((x) => {
        const exist = this.departamentos.find((y) => y.idDepa == x);
        if (exist) {
          lista.push(exist);
        }
      });
      return lista;
    },
    _provincias() {
      let items = [];
      this._datos.map((x) => {
        if (this.departamentoSelected == x.idDepa) {
          items.push(x.idProv);
        }
      });
      const uniqueItems = [...new Set(items)];
      let lista = [];
      uniqueItems.map((x) => {
        const exist = this.provincias.find((y) => y.idProv == x);
        lista.push(exist);
      });
      return lista;
    },
    _distritos() {
      let items = [];
      this._datos.map((x) => {
        if (this.provinciaSelected == x.idProv) {
          items.push(x.idUbigeo);
        }
      });
      const uniqueItems = [...new Set(items)];
      let lista = [];
      uniqueItems.map((x) => {
        const exist = this.distritos.find((y) => y.idUbigeo == x);
        lista.push(exist);
      });
      return lista;
    },
  },
  async created() {
    const lista = [];
    let hostname =
      location.hostname == "localhost"
        ? "www.grupo-cayman.com"
        : location.hostname;
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    if (hostname == "www.grupo-cayman.com" || hostname == "grupo-cayman.com") {
      hostname = "grupo-cayman.com";
      lista.push({
        text: "PUNTOS DE VENTA AUTORIZADO",
        id: "id_punto_de_venta",
      });
    }
    const { data } = await axios({
      url: `https://ms.prod.innout.cloud/ms/servicios/pk/v1.1/cayman/obtener/locales`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        mode: "cors",
        authorization: `Bearer 33825c48-243c-4c19-9406-1c4a4aabb7ac`,
      },
      data: {
        host: hostname,
        //host : "azelli.com.pe"
      },
    });
    loading.close();
    const lsTienda = data.filter((x) => x.idTipoLocal == "id_tienda_propia");
    if (lsTienda.length > 0) {
      lista.push({ text: "TIENDA PROPIA", id: "id_tienda_propia" });
    }
    const lsRepuestos = data.filter((x) => x.idTipoLocal == "id_repuestos");
    if (lsRepuestos.length > 0) {
      lista.push({ text: "REPUESTOS", id: "id_repuestos" });
    }
    const lsTalleres = data.filter((x) => x.idTipoLocal == "id_talleres");
    if (lsTalleres.length > 0) {
      lista.push({ text: "TALLERES", id: "id_talleres" });
    }

    this.locales = lista;

    this.datos = data;
  },
};
</script>
<style>
* {
  /* font-family: "Poppins", sans-serif; */
  font-family: "Roboto Web", sans-serif;
  /* azelli   "Titillium Web", sans-serif;*/
  /* zongsheng "Roboto Web", sans-serif; */
}
h6 {
  padding: 2px;
  margin: 2px;
}

.mainContainer {
  display: flex;
  justify-content: center;
  justify-items: center;
  padding: 16px;
  background: #fafafa;
}
.centerContainer {
  max-width: 1024px;
  display: flex;
  justify-content: center;
  justify-items: center;
  background: #fefefe;
}
.mainSelect {
  padding: 8px 0;
}
.leftMainRow {
  background: #fafafa;
  min-height: 480px;
  padding: 16px;
}
.mainForm {
  padding: 16px;
  background: #fafafa;
  border-radius: 16px;
  /* border:2px solid #F5F5F5; */
}
.mainLeftBorder {
  background: #eeeeee;
}
.rightMainRow {
  background: #fafafa;
  min-height: 480px;

  padding: 16px;
  display: flex;
}
.el-select {
  width: 100%;
  box-sizing: border-box;
}
.leftTable {
  align-items: center;
  font-weight: bold; /* same as 700 */
}
.rightTable {
  box-sizing: border-box;
  font-weight: normal; /* same as 700 */
}
.itemContainer {
  padding: 0 16px;
}
.itemTable {
  padding: 16px 0 0 0;
}
.mainTitle {
  font-size: 18px;
  color: #df030a;
}
.mainsubtitle {
  font-size: 17px;
  color: #212121;
  font-weight: bold; /* same as 700 */
}
.mainDescription {
  font-size: 14px;
  color: #424242;
  font-weight: bold; /* same as 700 */
}
.requiredColor {
  color: #df030a;
}

@media only screen and (max-width: 600px) {
  .mainContainer {
    padding: 0px;
  }
  .leftMainRow {
    padding: 8px;
    min-height: 100px;
  }
  .mainForm {
    padding: 8px;
  }
}
</style>
